import { render, staticRenderFns } from "./ResumeBackground.vue?vue&type=template&id=93a6774c&scoped=true&"
import script from "./ResumeBackground.vue?vue&type=script&lang=js&"
export * from "./ResumeBackground.vue?vue&type=script&lang=js&"
import style0 from "./ResumeBackground.vue?vue&type=style&index=0&id=93a6774c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93a6774c",
  null
  
)

export default component.exports